class VendorGridRotator {
  constructor(gridElement) {
    this.grid = gridElement;
    this.collectionsData = this.loadCollections();
    this.currentIndices = Array.from({ length: 9 }, (_, i) => i);
    this.rotationInterval = parseInt(this.grid.dataset.rotationInterval) || 3000;
    this.hoveredSlots = new Set();
    
    this.setupHoverListeners();
    
    if (this.collectionsData.length > 9) {
      this.startRotation();
    }
  }
  
  setupHoverListeners() {
    const items = this.grid.querySelectorAll('.vendor-grid__item');
    items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        this.hoveredSlots.add(index);
      });
      
      item.addEventListener('mouseleave', () => {
        this.hoveredSlots.delete(index);
      });
    });
  }
  
  loadCollections() {
    const script = document.querySelector('[data-vendor-collections]');
    return script ? JSON.parse(script.textContent) : [];
  }
  
  startRotation() {
    setInterval(() => {
      this.rotateRandomSlot();
    }, this.rotationInterval);
  }
  
  rotateRandomSlot() {
    // Pick a random slot to rotate
    const slotIndex = Math.floor(Math.random() * 9);
    const content = this.grid.querySelector(`[data-slot="${slotIndex}"]`);
    
    if (!content) return;
    
    // Skip if currently being hovered
    if (this.hoveredSlots.has(slotIndex)) return;
    
    // Skip if already transitioning
    const existingOverlay = content.querySelector('.vendor-grid__logo-overlay');
    if (existingOverlay) return;
    
    // Get a new random collection that's not currently displayed AND different from what's in this slot
    const currentCollectionIndex = this.currentIndices[slotIndex];
    let newCollectionIndex;
    let attempts = 0;
    const maxAttempts = 100;
    
    do {
      newCollectionIndex = Math.floor(Math.random() * this.collectionsData.length);
      attempts++;
      // Safety fallback after max attempts
      if (attempts >= maxAttempts) {
        // Find any collection not currently displayed and not the current one
        for (let i = 0; i < this.collectionsData.length; i++) {
          if (!this.currentIndices.includes(i) && i !== currentCollectionIndex) {
            newCollectionIndex = i;
            break;
          }
        }
        // If still nothing found, just pick any that's different from current
        if (newCollectionIndex === currentCollectionIndex || this.currentIndices.includes(newCollectionIndex)) {
          for (let i = 0; i < this.collectionsData.length; i++) {
            if (i !== currentCollectionIndex) {
              newCollectionIndex = i;
              break;
            }
          }
        }
        break;
      }
    } while (this.currentIndices.includes(newCollectionIndex) || newCollectionIndex === currentCollectionIndex);
    
    // Update the current indices
    this.currentIndices[slotIndex] = newCollectionIndex;
    const collection = this.collectionsData[newCollectionIndex];
    
    // Clone current content to create overlay
    const currentLink = content.querySelector('a');
    const currentImg = content.querySelector('.vendor-grid__logo');
    
    if (!currentLink || !currentImg) return;
    
    // Create overlay with current image (clone before changing src)
    const overlay = document.createElement('div');
    overlay.className = 'vendor-grid__logo-overlay';
    const overlayImg = currentImg.cloneNode(true);
    overlay.appendChild(overlayImg);
    
    // Add overlay to the link (positioned absolutely within it)
    currentLink.appendChild(overlay);
    
    // Now update the underlying content with new logo
    currentLink.href = collection.url;
    currentImg.src = collection.logo;
    currentImg.alt = collection.title;
    currentImg.setAttribute('aria-label', collection.title);
    
    // IMPORTANT: Remove srcset so browser uses the src we just set
    currentImg.removeAttribute('srcset');
    currentImg.removeAttribute('width');
    currentImg.removeAttribute('height');
    
    // Trigger dissolve animation after a brief delay to ensure DOM is ready
    requestAnimationFrame(() => {
      overlay.classList.add('dissolving');
      
      // Remove overlay after animation completes
      setTimeout(() => {
        overlay.remove();
      }, 1000);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVendorGrid);
} else {
  initVendorGrid();
}

function initVendorGrid() {
  const grids = document.querySelectorAll('.vendor-grid');
  grids.forEach(grid => new VendorGridRotator(grid));
}
